package music.jammers.shared.event.track.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class EventTrackBackgroundInfo(
    val color: String,
    val type: BackgroundType,
)
